<script>
  import PromoBanners from '@/components/lobby/PromoBanners.vue';
  import HostedRooms from '@/views/challenge-friends/components/HostedRooms.vue';
  import ChallengeFriends from '@/views/challenge-friends/components/ChallengeFriends.vue';
  import FriendsList from '@/views/challenge-friends/components/FriendsList.vue';

  export default {
    name: 'ChallengeFriendsView',

    components: {
      HostedRooms,
      FriendsList,
      ChallengeFriends,
      PromoBanners,
    },

    data: () => ({
      banners: [
        {
          src: '/images/banners/add-friends.webp?v=3',
          alt: 'Add Friends',
        },
        {
          src: '/images/banners/challenge-friends.webp?v=4',
          alt: 'Challenge friends',
        },
        {
          src: '/images/banners/refer-a-friend.webp?v=3',
          alt: 'Refer a friend',
          to: '/referfriends',
        },
      ],
    }),
  };
</script>

<template>
  <div class="caf-container">
    <PromoBanners v-if="banners.length" :banners="banners" dense />

    <div class="content-wrapper">
      <div class="caf-card bordered">
        <ChallengeFriends />
      </div>

      <div class="caf-card">
        <FriendsList />
      </div>

      <div class="caf-card">
        <HostedRooms />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  @import 'src/scss/mixins';

  .caf-container {
    padding: 24px 22px;
    container-name: caf-container;
    container-type: inline-size;
    @include basic-spacings;
    padding-inline: 12px;

    @media screen and (min-width: 1281px) {
      width: 100%;
      max-width: calc(100vw - 389px - 64px);
      margin-inline: auto;
      padding-inline: 0;
    }

    @media screen and (min-width: 1842px) {
      max-width: 1448px;
      padding-right: 32px;
    }

    ::v-deep .promo-banners .promo-banner {
      overflow: hidden;
    }

    .content-wrapper {
      display: grid;
      grid-template-columns: 1fr 2fr;
      grid-template-rows: repeat(2, 1fr);
      margin-top: 24px;
      gap: 24px;

      .caf-card {
        background: #24073d;
        border-radius: 10px;
        padding: 28px 30px;

        &.bordered {
          container-name: caf-wrapper;
          container-type: inline-size;
          border: 1px solid var(--v-gold-base);
          grid-row: span 2;
          min-width: 510px;
          display: flex;
        }

        @container caf-wrapper (width > 700px) {
          &::v-deep {
            .caf-title {
              width: 100%;
              justify-content: center;
            }
          }
        }
      }
    }

    @container caf-container (width < 1100px) {
      .content-wrapper {
        grid-template-columns: 1fr;
        grid-template-rows: 2fr 1fr 1fr;

        .caf-card.bordered {
          grid-row: unset;
        }
      }
    }

    @media screen and (max-width: 768px) {
      padding-bottom: 60px;

      .content-wrapper .caf-card.bordered {
        min-width: unset;
      }
    }

    @media screen and (max-width: 600px) {
      .content-wrapper {
        grid-template-rows: auto auto auto;

        .caf-card {
          padding: 16px;
        }
      }
    }
  }
</style>
